import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["calendar", "endOfDay", "startOfDay"];
  static values = { textClass: String, calendarIconClass: String };

  connect() {

    const $el = $(this.calendarTarget);

    $el.daterangepicker({
      autoApply: true,
      opens: "right",
    });

    $el.on("show.daterangepicker", (ev, picker) => {
      this.setPickerContainerStyles(picker);
      this.setInitialDates(picker);
      if (!$(picker.container).attr("data-input-event")) {
        this.attachOnEnterKeypressListener(picker);
        $(picker.container).attr("data-input-event", "true");
      }
    });

    $el.on("showCalendar.daterangepicker", (ev, picker) => {
      this.setPickerContainerPositions(picker);
    });

    $el.on("apply.daterangepicker", (ev, picker) => {
      this.onApplyDatePicker(picker);
    });
    
  }

  setPickerContainerStyles(picker) {
    const textClass = this.textClassValue || "";
    const calendarIconClass = this.calendarIconClassValue || "";

    $(picker.container).addClass("daterangepicker--payments");
    this.setPickerContainerPositions(picker);

    $(picker.container)
      .find(".daterangepicker_input")
      .each((i, el) => {
        const $calendarInput = $(el);
        const $input = $calendarInput.find("input");

        $input.removeClass("form-control");
        if (textClass) $input.addClass(textClass);

        const $inputIcon = $calendarInput.find("i");
        $inputIcon.removeClass();
        if (calendarIconClass) $inputIcon.addClass(calendarIconClass);
      });
  }

  setPickerContainerPositions(picker) {
    $(picker.container).css({ top: "-=1px", left: "-=1px" });
  }

  setInitialDates(picker) {
    const $el = $(this.calendarTarget);
    const endDateInitial = this.endOfDayTarget.value;
    const startDateInitial = this.startOfDayTarget.value;

    // hidden input values are valid ISO 8601 dates
    if (window.moment(startDateInitial, window.moment.ISO_8601, true).isValid() &&
        window.moment(endDateInitial, window.moment.ISO_8601, true).isValid()) {
      // Convert ISO 8601 to the picker's locale format for display
      const formattedStart = window.moment(startDateInitial, window.moment.ISO_8601).format(picker.locale.format);
      const formattedEnd = window.moment(endDateInitial, window.moment.ISO_8601).format(picker.locale.format);
      
      $(picker.container).find("input[name='daterangepicker_start']").val(formattedStart);
      $(picker.container).find("input[name='daterangepicker_end']").val(formattedEnd);
      $el.data('daterangepicker').setStartDate(formattedStart);
      $el.data('daterangepicker').setEndDate(formattedEnd);
    }
  }

  attachOnEnterKeypressListener(picker) {
    const $el = $(this.calendarTarget);
    // On enter keydown force apply of the selected dates
    $(picker.container).find("input[name='daterangepicker_start'],input[name='daterangepicker_end']").on("keydown", (event) => {
      if (event.key === "Enter") {
        // waiting for the daterangepicker to process the input end value
        setTimeout(() => {
          // Validate user-entered dates are in the picker's locale format
          const start = $(picker.container).find("input[name='daterangepicker_start']").val();
          const end = $(picker.container).find("input[name='daterangepicker_end']").val();

          if (!window.moment(start, picker.locale.format, true).isValid() ||
              !window.moment(end, picker.locale.format, true).isValid()) {
            return;
          }

          $el.data('daterangepicker').setStartDate(window.moment(start, picker.locale.format));
          $el.data('daterangepicker').setEndDate(window.moment(end, picker.locale.format));
          $el.data('daterangepicker').clickApply();
        });
      }
    });
  }

  onApplyDatePicker(picker) {
    const start = picker.startDate;
    const end = picker.endDate;

    this.startOfDayTarget.value = window.moment(start).startOf("day").toISOString(false);
    this.endOfDayTarget.value = window.moment(end).endOf("day").toISOString(false);

    this.dispatchUpdateEvent();
  }

  onDropdownOpened(_event) {
    this.calendarTarget.click();
  }

  dispatchUpdateEvent() {
    const startDate = window.moment(this.startOfDayTarget.value).toDate();
    const endDate = window.moment(this.endOfDayTarget.value).toDate();

    window.dispatchEvent(new CustomEvent("datepicker:update", {
      target: this.element,
      detail: {
        label: `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`,
      },
    }));

    if (this.element.dataset.submitOnSelect === "true" && this.startOfDayTarget.form) {
      this.startOfDayTarget.form.requestSubmit();
    }
  }

  reset() {
    this.startOfDayTarget.value = "";
    this.endOfDayTarget.value = "";

    if (this.element.dataset.submitOnSelect === "true" && this.startOfDayTarget.form) {
      this.startOfDayTarget.form.requestSubmit();
    }
  }
}
